import React from "react";
import { Link } from "react-router-dom";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="min-h-[calc(100vh-72px)] flex items-center justify-center px-4 py-16 bg-[#FDFBF7]">
      <Card className="p-10 max-w-md w-full text-center border-[#EAE3D2] bg-white">
        <XCircle className="w-16 h-16 mx-auto text-slate-500" />
        <h1 className="font-serif text-3xl text-slate-900 mt-4">Checkout cancelled</h1>
        <p className="text-slate-600 mt-2">No worries — you can try again any time.</p>
        <Link to="/pricing"><Button className="mt-6 bg-[#6B1D2F] hover:bg-[#541624] text-white rounded-full px-8">Back to plans</Button></Link>
      </Card>
    </div>
  );
}
